var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard background"},[_c('dashboard-page',{attrs:{"pcontent":"0","page":"DISCOUNTS"}},[_vm._v("content here")]),_c('tool-bar'),_c('right-menu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }